__webpack_require__.p = "/fr-CH/";